/* eslint-disable */
import { produce } from "immer";
import {
  TRANSACTIONS_SUMMARY_FETCH_START,
  TRANSACTIONS_SUMMARY_FETCH_SUCCESS,
  TRANSACTIONS_SUMMARY_FETCH_FAILURE,
} from "../actions/types";

const transactionsSummary = (
  state = {
    transactionsSummaryFetching: false,
    transactionsSummaryData: [],
    transactionsSummaryError: null,
  },
  action,
) => {
  switch (action.type) {
    case TRANSACTIONS_SUMMARY_FETCH_START:
      return produce(state, (draft) => {
        draft.transactionsSummaryFetching = true;
      });
    case TRANSACTIONS_SUMMARY_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.transactionsSummaryFetching = true;
        draft.transactionsSummaryData = action.data;
        draft.transactionsSummaryFetching = false;
      });
    case TRANSACTIONS_SUMMARY_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.transactionsSummaryFetching = false;
        draft.transactionsSummaryError = action.error;
      });
    default:
      return state;
  }
};

export default transactionsSummary;
